/*!
 DataTables styling integration
 ©2018 SpryMedia Ltd - datatables.net/license
*/
(function(c){"function"===typeof define&&define.amd?define(["jquery","datatables.net"],function(a){return c(a,window,document)}):"object"===typeof exports?module.exports=function(a,b){a||(a=window);b&&b.fn.dataTable||(b=require("datatables.net")(a,b).$);return c(b,a,a.document)}:c(jQuery,window,document)})(function(c,a,b,d){return c.fn.dataTable});



//////////////////
// WEBPACK FOOTER
// /buddy/raceplanet-theme/node_modules/datatables.net-dt/js/dataTables.dataTables.min.js
// module id = 814
// module chunks = 3